module.exports = __webpack_public_path__ + "img/avatar1.4703472e.jpg";